<template>
  <span class="c-button-root">
    <button
        v-bind="$attrs"
        v-if="!to && !href"
        :disabled="showIndicator || disabled"
        :class="`c-button
                ${outline ? 'c-button--outline' : ''}
                ${fill ? 'c-button--fill' : ''}
                ${uppercase ? 'c-button--uppercase' : ''}
                btn
                btn-${theme}
                btn-${size} ${className}`"
        @click="$emit('click')"
        :type="type"
    >
      <!-- Keyed by icon: Font Awesome swaps the <i> for an <svg>, so Vue can only change
           the icon by replacing this wrapper, which stays in the DOM. -->
      <span :key="icon" :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'" class="c-button-icon__wrapper">
        <i v-if="icon" :class="`fa-regular ${icon}`"></i>
        <img v-if="iconSrc" :src="iconSrc" width="15"/>
      </span>
      <span :style=" showIndicator ? 'opacity: 0;' : 'opacity: 1;'" class="c-button__slot">
       <slot></slot>
      </span>
      <div class="button-preloader" v-if="showIndicator">
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
        <span class="button-preloader__dot"/>
      </div>
    </button>

    <a
        v-bind="$attrs"
        :disabled="showIndicator || disabled"
        v-if="href"
        :href="href"
        :class="`c-button
                ${outline ? 'c-button--outline' : ''}
                ${fill ? 'c-button--fill' : ''}
                 ${uppercase ? 'c-button--uppercase' : ''}
                btn
                btn-${theme}
                btn-${size} ${className}`"
        @click="$emit('click')"
    >
      <span :key="icon" class="c-button-icon__wrapper">
        <i v-if="icon" :class="`fa-regular ${icon}`"></i>
        <img v-if="iconSrc" :src="iconSrc" width="15"/>
      </span>
      <span class="c-button__slot">
        <slot></slot>
      </span>
    </a>

    <router-link
        v-bind="$attrs"
        v-if="to"
        :to="disabled ? '' : to"
        :class="`c-button
        ${outline ? 'c-button--outline' : ''}
        ${fill ? 'c-button--fill' : ''}
         ${uppercase ? 'c-button--uppercase' : ''}
        btn btn-${theme}
        btn-${size} ${className}`"
        @click="$emit('click')"
        :disabled="showIndicator || disabled"
    >
      <span :key="icon" class="c-button-icon__wrapper">
        <i v-if="icon" :class="`fa-regular ${icon}`"></i>
         <img v-if="iconSrc" :src="iconSrc" width="15"/>
      </span>
      <span class="c-button__slot">
        <slot></slot>
      </span>
    </router-link>
  </span>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'success'
    },
    size: {
      type: String,
      default: 'md'
    },
    type: {
      type: String,
      default: 'button'
    },
    to: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    showIndicator: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    fill: {
      type: Boolean,
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>

.c-button-root {
  display: inline-block;
}

.btn {
  &:disabled {
    cursor: not-allowed;
  }
}



.c-button {
  position: relative;

  --button-color--default: #ffffff;
  --button-color--primary: #337ab7;
  --button-color--success: #5cb85c;
  --button-color--danger: #d9534f;
  --button-color--warning: #f0ad4e;
  --button-color--info: #5bc0de;
  --button-color--disable: #b6b6b6;
  --button-color--purpule: #7b3ac9;

  &--uppercase {
    text-transform: uppercase;

    * {
      text-transform: uppercase;
    }
  }

  &__slot{
    margin: 0;
    padding: 0;
    text-decoration: none;
  }


  &--outline, &--fill {
    background-color: rgba(0, 0, 0, 0) !important;
    display: grid !important;
    grid-template-columns: 30px 1fr;
    gap: 13px;
    border-radius: 8px;
    //align-items: baseline;



    *{
      box-sizing: border-box !important;
    }

    svg, i {
      color: inherit !important;
      margin: 0 auto;
      padding-right: 10px;
    }

    .c-button-icon__wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      //padding-right: 8px;

      line-height: 0;

      *{
        line-height: 0;
      }
    }

  }


  &--outline{

    &.btn-primary {
      border: 1px solid var(--button-color--primary) !important;
      color: var(--button-color--primary);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--primary);
      }
    }

    &.btn-default {
      color: #333;
      border: 1px solid #333 !important;

      .c-button-icon__wrapper {
        border-right: 1px solid #333;
      }
    }

    &.btn-info {
      border: 1px solid var(--button-color--info) !important;
      color: var(--button-color--info);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--info);
      }
    }

    &.btn-danger {
      border: 1px solid var(--button-color--danger) !important;
      color: var(--button-color--danger);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--danger);
      }
    }

    &.btn-success {
      border: 1px solid var(--button-color--success) !important;
      color: var(--button-color--success);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--success);
      }
    }

    &.btn-warning {
      border: 1px solid var(--button-color--warning) !important;
      color: var(--button-color--warning);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--warning);
      }
    }

    &.btn-purple{
      border: 1px solid var(--button-color--purpule) !important;
      color: var(--button-color--purpule);

      .c-button-icon__wrapper {
        border-right: 1px solid var(--button-color--purpule);
      }
    }

  }



  &--fill {
    &.btn-primary {
      border: 1px solid var(--button-color--primary) !important;
      background-color: var(--button-color--primary) !important;;
      color: white;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-default {
      color: white;
      border: 1px solid #333 !important;
      background-color: #333 !important;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-info {
      border: 1px solid var(--button-color--info) !important;
      color: white;
      background-color: var(--button-color--info) !important;;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-danger {
      border: 1px solid var(--button-color--danger) !important;
      color: white;
      background-color: var(--button-color--danger) !important;;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-success {
      border: 1px solid var(--button-color--success) !important;
      color: white;
      background-color: var(--button-color--success) !important;;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-warning {
      border: 1px solid var(--button-color--warning) !important;
      color: white;
      background-color: var(--button-color--warning) !important;;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }

    &.btn-purple{
      border: 1px solid var(--button-color--purpule) !important;
      color: white;
      background-color: var(--button-color--purpule) !important;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }
    &[disabled],
    &:disabled {
      border: 1px solid var(--button-color--disable) !important;
      color: white;
      background-color: var(--button-color--disable) !important;;

      .c-button-icon__wrapper {
        border-right: 1px solid white;
      }
    }


  }

  img {
    margin-right: 7px;
  }
}

.btn-default {
  .button-preloader {
    .button-preloader__dot {
      background-color: #ccc;
    }
  }
}

.button-preloader {
  display: flex;
  position: absolute;
  top: calc(50% - 6px);
  left: calc(50% - 18px);

  .button-preloader__dot {
    border-radius: 6px;
    display: block;
    width: 6px;
    height: 6px;
    margin: 3px;
    background-color: white;

    &:first-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-iteration-count: infinite;
    }

    &:nth-child(2) {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.1s;
      animation-iteration-count: infinite;
    }

    &:last-child {
      animation-name: run-dots;
      animation-duration: 1s;
      animation-delay: 0.2s;
      animation-iteration-count: infinite;
    }
  }

  @keyframes run-dots {
    from {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
}
</style>
